import { render } from "./BaseSkeletonImage.vue?vue&type=template&id=dbbd6588"
import script from "./BaseSkeletonImage.vue?vue&type=script&lang=js"
export * from "./BaseSkeletonImage.vue?vue&type=script&lang=js"
script.render = render

export default script